import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiateRemoteCheckDepositRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { InitiateRemoteCheckDepositResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const initiateRemoteCheckDeposit = (request: InitiateRemoteCheckDepositRequest, options?: CashRequestOptions) =>
  post<InitiateRemoteCheckDepositRequest, InitiateRemoteCheckDepositResponse>(
    '/2.0/cash/initiate-remote-check-deposit',
    request,
    { ...options, rejectOnError: true }
  )
